<template>
  <div>
    <or-layout>
      <a-button class="editable-add-btn" @click="showModal" style="margin-bottom: 10px;">添加</a-button>
      <a-table bordered :data-source="dataSource" :columns="columns" :rowKey="record => record.id">
        <!-- <template slot="name" slot-scope="text, record">
          <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
        </template> -->
        <template slot="status" slot-scope="text,record">
          <a-switch checked-children="开" un-checked-children="关" :checked="text == '1' ? true : false"
            :loading="switchloading" @change="switchChange(record)" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <!-- <a href="javascript:;" @click="lookDetail(record.id)">详情</a>
          <a-divider type="vertical" /> -->
          <!-- <a href="javascript:;">编辑</a>
          <a-divider type="vertical" /> -->
          <a-popconfirm v-if="dataSource.length" title="确定要删除吗?" @confirm="() => onDelete(record.id)">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </or-layout>
    <a-modal title="添加" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
      <a-form ref="addForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item label="版本ID" name="version_id">
          <a-input v-model="addForm.version_id" :disabled="type == 'detail'" />
        </a-form-item>
        <a-form-item label="版本编号" name="version_number">
          <a-input v-model="addForm.version_number" :disabled="type == 'detail'" />
        </a-form-item>
        <a-form-item label="版本描述" name="version_desc">
          <a-input v-model="addForm.version_desc" :disabled="type == 'detail'" />
        </a-form-item>
        <a-form-item label="版本类型" name="version_type">
          <a-input v-model="addForm.version_type" :disabled="type == 'detail'" />
        </a-form-item>
        <a-form-item label="设备类型" name="device_type">
          <!-- <a-input v-model="addForm.device_type" :disabled="type == 'detail'" /> -->
          <a-select v-model="addForm.device_type" :default-value="addForm.device_type" style="width: 120px">
            <a-select-option value="android">Android</a-select-option>
            <a-select-option value="ios">IOS</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="APPID" name="appid">
          <a-input v-model="addForm.appid" :disabled="type == 'detail'" />
        </a-form-item>
        <a-form-item label="下载地址" name="download_url">
          <uploadVue v-model="addForm.download_url" mode="file" :show="false"></uploadVue>
          <!-- <a-input v-model="addForm.download_url" :disabled="type == 'detail'" /> -->
          <!-- <a-upload name="file" :multiple="true" action="http://ycsx.tk123.top/admin/oss/get_upload_sign"
            :headers="headers" @change="handleChange">
            <a-button> <a-icon type="upload" /> Click to Upload </a-button>
          </a-upload> -->
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
  },
  {
    title: '版本ID',
    dataIndex: 'version_id',
    scopedSlots: { customRender: 'version_id' },
  },
  {
    title: '版本编号',
    dataIndex: 'version_number',
    scopedSlots: { customRender: 'version_number' },
  },
  {
    title: '版本描述',
    dataIndex: 'version_desc',
    scopedSlots: { customRender: 'version_desc' },
  },
  {
    title: '版本类型',
    dataIndex: 'version_type',
    scopedSlots: { customRender: 'version_type' },
  },
  {
    title: '设备类型',
    dataIndex: 'device_type',
    scopedSlots: { customRender: 'device_type' },
  },
  {
    title: 'APPID',
    dataIndex: 'appid',
    scopedSlots: { customRender: 'appid' },
  },
  {
    title: '下载地址',
    dataIndex: 'download_url',
    width: '300px',
    scopedSlots: { customRender: 'download_url' },
  },
  {
    title: 'APP状态',
    dataIndex: 'status',
    width: '100px',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
]
import uploadVue from '../components/upload.vue';
import { message } from 'ant-design-vue'
export default {
  name: "Home",
  components: {
    uploadVue
  },
  data() {
    return {
      dataSource: [],
      count: 0,
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
      type: 'add',
      addForm: {
        version_id: '',
        version_number: '',
        version_desc:'',
        version_type: '',
        device_type: 'android',
        appid: '',
        download_url: ''
      },
      headers:{
        'Authorization': localStorage.getItem('token')
      },
      switchloading: false,
      columns
    };
  },
  created() {
    this.getAppInfo()
  },
  methods: {
    showModal() {
      this.type = 'add';
      this.visible = true;
      this.addForm = {
        version_id: '',
        version_number: '',
        version_desc:'',
        version_type: '',
        device_type: '',
        appid: '',
        download_url: ''
      }
    },
    handleOk(e) {
      if (this.type == 'detail') {
        this.visible = false;
        return;
      }
      this.confirmLoading = true;
      let { version_id, version_number, version_type, device_type, appid, download_url } = this.addForm;
      this.$axios.post('/api/AppDownload/add', {
        data: {
          version_id, version_number, version_type, device_type, appid, download_url
        }
      }).then(res => {
        if (res.code === 200) {
          message.success('添加成功')
          this.visible = false;
          this.getAppInfo()
        } else {
          message.error('添加失败')
        }
        this.confirmLoading = false;
      }).catch(error => {
        message.error('添加失败')
        this.confirmLoading = false;
      })
    },
    handleCancel(e) {
      this.visible = false;
    },
    switchChange(record) {
      this.switchloading = true;
      this.dataSource.forEach(item => {
        if (item.id == record.id) {
          this.$set(item, 'status', record.status == '1' ? '0' : '1')
        }
      })
      this.$axios.post('/api/AppDownload/set_status', { data: { id: record.id, status: record.status } }).then(res => {
        if (res.code === 200) {
          message.success(res.data)
        } else {
          message.error(res.data)
        }
        this.switchloading = false;
      }).catch(error => {
        this.switchloading = false;
        console.warn(error);
      })
    },
    lookDetail(id) {
      this.visible = true;
      this.type = 'detail'
      this.$axios.post('/api/AppDownload/find', { data: { id } }).then(res => {
        if (res.code === 200) {
          let { version_id, version_number, version_type, device_type, appid, download_url } = res.data;
          this.addForm = { version_id, version_number, version_type, device_type, appid, download_url }
        }
      }).catch(error => {

      })
    },
    getAppInfo() {
      this.$axios.post('/api/AppDownload/list').then(res => {
        if (res.code === 200) {
          this.dataSource = res.data.data;
        }
      }).catch(error => {
        console.log(error);
      })
    },
    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.dataSource];
      const target = dataSource.find(item => item.key === key);
      if (target) {
        target[dataIndex] = value;
        this.dataSource = dataSource;
      }
    },
    onDelete(id) {
      this.$axios.post('/api/AppDownload/dell', { data: { id } }).then(res => {
        if (res.code === 200) {
          message.success('删除成功');
          this.dataSource = this.dataSource.filter(item => item.id !== id)
        } else {
          message.error('删除失败')
        }
      }).catch(error => {
        message.error('删除失败')
      })
      /* const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.key !== key); */
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        name: `Edward King ${count}`,
        age: 32,
        address: `London, Park Lane no. ${count}`,
      };
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
  },
};
</script>
